import {createContext} from "react";

export default createContext({
	workTypes: [],
	loading: false,
	getWorkTypes: () => {},
	editWorkType: () => {}
});